/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audio_Description_Export_Loudness_MixdownInputs */



/**
* | output |
* | --- |
* | "Mixdown" |
*
* @param {Audio_Description_Export_Loudness_MixdownInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const audio_description_export_loudness_mixdown = /** @type {((inputs?: Audio_Description_Export_Loudness_MixdownInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audio_Description_Export_Loudness_MixdownInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Mixdown")
	if (locale === "de") return /** @type {LocalizedString} */ ("Mixdown")
	if (locale === "it") return /** @type {LocalizedString} */ ("Mixaggio")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Миксдаун")
	if (locale === "es") return /** @type {LocalizedString} */ ("Mezcla")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("混战")
	if (locale === "ja") return /** @type {LocalizedString} */ ("ミックスダウン")
	if (locale === "hi") return /** @type {LocalizedString} */ ("बहुत चुप")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Mixagem")
	return /** @type {LocalizedString} */ ("Mixdown")
});